import { render, staticRenderFns } from "./product-material.vue?vue&type=template&id=7dc5c37c&scoped=true&lang=pug&"
import script from "./product-material.vue?vue&type=script&lang=ts&"
export * from "./product-material.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc5c37c",
  null
  
)

export default component.exports